import { useTranslation } from 'react-i18next';
import getContentItemType, { getContentItemTypeTranslationKey } from 'utils/asset/getContentItemType';
import { getContentItemIconFromType } from 'utils/icons';
import getContentProgress from 'utils/asset/getContentProgress';
import { checkIsAsset, checkIsPlaylist } from 'types/content/utils';
export function useCardContentDetails(cardContent) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var completionTime = cardContent.completionTime,
    userContentStatus = cardContent.userContentStatus;
  var contentType = getContentItemType(cardContent);
  var isPlaylist = checkIsPlaylist(cardContent);
  var isAsset = checkIsAsset(cardContent);
  var completionRate = isPlaylist ? cardContent.completionRate : 0;
  var playlistContentCount = isPlaylist ? cardContent.contentCount : 0;
  var progress = getContentProgress({
    isPlaylist: isPlaylist,
    userContentStatus: userContentStatus,
    userScormAssetStatus: isAsset ? cardContent === null || cardContent === void 0 ? void 0 : cardContent.userScormAssetStatus : undefined,
    completionRate: completionRate
  });
  var completedContentCount = Math.round(+completionRate * +playlistContentCount);
  var cardContentType = {
    value: contentType,
    readable: t(getContentItemTypeTranslationKey(contentType))
  };
  var contentCount = {
    value: playlistContentCount,
    readable: t('playlist_item_count', {
      count: playlistContentCount
    })
  };
  return {
    contentCount: contentCount,
    completedContentCount: completedContentCount,
    duration: completionTime * 60,
    progress: progress,
    type: cardContentType,
    icon: getContentItemIconFromType(contentType)
  };
}